import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Button
} from "reactstrap";

//import images
import logoLight from "../assets/images/logo-light.png";

//import Components
import ProfileDropdown from "../Components/Common/ProfileDropdown";
import { authenticateWithTokenAdmin } from "../utils/utils";

import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { useCurrentUser } from "../slices/auth/hooks";
import { changeSidebarVisibility } from "../slices/thunks";

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }) => {
  const dispatch = useDispatch();
  const currentUser = useCurrentUser();
  const globalTheme = useSelector(state => state.Theme);

  const logo = globalTheme?.logo || logoLight;


  console.log("globalTheme", globalTheme, logo);

  const { sidebarVisibilitytype } = useSelector((state) => ({
    sidebarVisibilitytype: state.Layout.sidebarVisibilitytype,
  }));

  const [search, setSearch] = useState(false);
  const toogleSearch = () => {
    setSearch(!search);
  };

  const toogleMenuBtn = () => {
    var windowSize = document.documentElement.clientWidth;

    if (windowSize > 767) {
      // document.querySelector(".hamburger-icon")?.classList.toggle("open");
      return;
    }
    dispatch(changeSidebarVisibility("show"));

    //For collapse horizontal menu
    if (document.documentElement.getAttribute("data-layout") === "horizontal") {
      document.body?.classList.contains("menu")
        ? document.body?.classList.remove("menu")
        : document.body?.classList.add("menu");
    }

    //For collapse vertical and semibox menu
    if (
      sidebarVisibilitytype === "show" &&
      (document.documentElement.getAttribute("data-layout") === "vertical" ||
        document.documentElement.getAttribute("data-layout") === "semibox")
    ) {
      if (windowSize < 1025 && windowSize > 767) {
        document.body?.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "sm"
          ? document.documentElement.setAttribute("data-sidebar-size", "")
          : document.documentElement.setAttribute("data-sidebar-size", "sm");
      } else if (windowSize > 1025) {
        document.body?.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "lg"
          ? document.documentElement.setAttribute("data-sidebar-size", "sm")
          : document.documentElement.setAttribute("data-sidebar-size", "lg");
      } else if (windowSize <= 767) {
        document.body?.classList.add("vertical-sidebar-enable");
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
    }

    //Two column menu
    if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
      document.body?.classList.contains("twocolumn-panel")
        ? document.body?.classList.remove("twocolumn-panel")
        : document.body?.classList.add("twocolumn-panel");
    }
  };

  const tokenUser = localStorage.getItem("tokenUser");

  const handleBackToAdmin = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to leave the user panel and go back to the admin panel.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, go back!",
      cancelButtonText: "No, cancel!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Success!",
          text: "You are now back to the admin panel!",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
        const response = await authenticateWithTokenAdmin();
        if (response === true) {
          window.location.reload();
        } else {
          Swal.fire({
            title: "Error!",
            text: "An error occurred while trying to go back to the admin panel!",
            icon: "error",
            showConfirmButton: true,
          });
        }
      }
    });
  };

  const getCurrentDate = () => {
    const options = { weekday: "long", month: "long", day: "numeric" };
    return new Date().toLocaleDateString("en-US", options);
  };

  const getGreeting = () => {
    const hours = new Date().getHours();
    if (hours < 12) {
      return "Good morning";
    } else if (hours < 18) {
      return "Good afternoon";
    } else {
      return "Good evening";
    }
  };

  return (
    <React.Fragment>
      <header id="page-topbar" className={headerClass}>
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box horizontal-logo mt-2">
                <Link to="/profile" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={logo} alt="" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img src={logo} alt="" height="40" />
                  </span>
                </Link>

                <Link to="/profile" className="logo logo-light">
                  <span className="logo-sm">
                    <img src={logo} alt="" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img src={logo} alt="" height="40" />
                  </span>
                </Link>
              </div>
              <button
                onClick={toogleMenuBtn}
                type="button"
                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger d-block d-md-none"
                id="topnav-hamburger-icon"
              >
                <span className="hamburger-icon">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>

              {/* <SearchOption /> */}
              <div className="d-flex flex-column ms-3 pt-2">
                <span className="text-dark">{getCurrentDate()}</span>
                <span className="fw-semibold" style={{ fontSize: "18px" }}>
                  {getGreeting()}, {currentUser.firstName?.split(" ")[0]}!
                </span>
              </div>
            </div>

            <div className="d-flex align-items-center">
              {/* <Dropdown isOpen={search} toggle={toogleSearch} className="d-md-none topbar-head-dropdown header-item">
                                <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                                    <i className="bx bx-search fs-22"></i>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                                    <Form className="p-3">
                                        <div className="form-group m-0">
                                            <div className="input-group">
                                                <input type="text" className="form-control" placeholder="Search ..."
                                                    aria-label="Recipient's username" />
                                                <button className="btn btn-primary" type="submit"><i
                                                    className="mdi mdi-magnify"></i></button>
                                            </div>
                                        </div>
                                    </Form>
                                </DropdownMenu>
                            </Dropdown> */}

              {/* <LightDark
                layoutMode={layoutModeType}
                onChangeLayoutMode={onChangeLayoutMode}
              /> */}

              {/* ProfileDropdown */}
              {tokenUser && (
                <Button
                  onClick={handleBackToAdmin}
                  className="btn btn-primary p-1 d-flex align-items-center"
                >
                  {/* <i className="bx bx-user  border rounded me-2"></i> */}
                  Back to Admin
                </Button>
              )}
              <ProfileDropdown />
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
